export function isAnimationControls(v) {
    return (v !== null &&
        typeof v === "object" &&
        typeof v.start === "function");
}
//# sourceMappingURL=is-animation-controls.js.map